import { 
  GetAllCardsInfo, 
  AddCard, 
  UpdateCard, 
  DeleteCard,
  GetBankInfo,
  GetLinkToken,
  CreateBankAccount,
  AddBankAccount,
  SetBankAccountDefault,
  DeleteBankAccount,
  ApplyDiscountCoupon,
  ConnectToSpreedly,
  GetCurrentPMB,
  GetAvailablePMBs,
  AddCustomerPMB,
  RemoveCustomerPMB,
  GetAllCoupons,
  CreateCoupon,
  UpdateCoupon,
  GetCouponUsers,
  RemoveCouponFromUser,
  GetAdminGateway,
  UpdateAdminGateway,
  GetAdminCard,
  UpdateAdminCard,
  GetAppProvider,
  RunTestBilling,
  GetClientBankAccount,
  UpdateClientBankAccount,
  DeleteClientBankAccount,
  DeleteCoupon
} from '@/api/billing';

// eslint-disable-next-line import/no-cycle

export const getAllCards = ({ commit, dispatch }) => {
  commit('CARDS_REQUEST_DISPATCH');

  dispatch('CheckAuth', null, {root: true})
    .then(() => GetAllCardsInfo()
      .then((res) => {
        commit('CARDS_REQUEST_SUCCESS');
        commit('UPDATE_BILLING_DATA', res.credit_cards);
      })
    );
}

export const addCard = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => AddCard(data)
    .then(() => {
      dispatch('getAllCards');
    })
  );

export const setAsDefaultCard = ({ dispatch, state }, id) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => UpdateCard(id, {
    source: {
      default: true,
    },
  })
    .then(() => {
      state.billingData.find(item => item.default).default = false;

      state.billingData.find(item => item.id === id).default = true;

      const newArr = state.billingData.filter(item => !item.default);
      const defaultCard = state.billingData.find(item => item.default);

      newArr.unshift(defaultCard);

      state.billingData = newArr;

      // dispatch('getAllCards');
    })
  );

export const updateCardExp = ({ dispatch }, params) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => UpdateCard(params.id, 
    {
      source: params.data,
    })
    .then(() => {
      dispatch('getAllCards');
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const deleteCard = ({ dispatch, state }, id) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => DeleteCard(id)
    .then(() => {
      state.billingData = state.billingData.filter(item => item.id !== id);
      // dispatch('getAllCards');
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getBankInfo = ({dispatch, commit}) => dispatch('CheckAuth', null, {root: true})
  .then(() => Promise.all([
    GetBankInfo(),
    GetLinkToken()
  ])
    .then(([acc, link]) => {
      commit('UPDATE_BANK_ACCOUNT_DATA', {
        acc,
        link
      });
      return '';
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createBankAccount = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateBankAccount(data)
    .then(res => {
      // dispatch('getBankInfo');
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addBankAccount = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddBankAccount(data)
    .then((res) => {
      dispatch('getBankInfo');
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const setBankAccountDefault = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => SetBankAccountDefault()
    .then((res) => {
      dispatch('getBankInfo');
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteBankAccount = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteBankAccount()
    .then((res) => {
      dispatch('getBankInfo');
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const applyCoupon = ({dispatch, state}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => ApplyDiscountCoupon(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const connectToSpreedly = ({dispatch, state}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectToSpreedly(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getCustomerPMB = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCurrentPMB()
    .then(res => {
      return res.private_mailbox;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getPMBList = () => GetAvailablePMBs()
  .then(res => {
    return res.available_private_mailboxes;
  })
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }));
  
export const addPMB = ({dispatch}, pmb) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddCustomerPMB(pmb)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const removePMB = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveCustomerPMB()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getCoupons = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAllCoupons()
    .then((res) => {
      return res.coupons;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const createCoupon = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateCoupon(data)
    .then((res) => {
      return res.coupon;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );
export const deleteCoupon = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCoupon(data)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const updateCoupon = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCoupon(data)
    .then((res) => {
      return res.coupon;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getCouponUsers = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCouponUsers(id)
    .then((res) => {
      return res.user_coupons;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const removeUsersCoupon = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveCouponFromUser(params)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getPaymentGateway = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminGateway()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const updatePaymentGateway = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
.then(() => UpdateAdminGateway(data)
  .then(res => {
    return res;
  })
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))
);

export const getCreditCard = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminCard()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const updateCreditCard = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateAdminCard(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getAdminStripe = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAppProvider()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const runTestBilling = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => RunTestBilling(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const getClientBankAccount = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetClientBankAccount()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const updateClientBankAccount = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateClientBankAccount(params)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const deleteClientBankAccount = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteClientBankAccount()
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );
